import React from "react";
import { ThermalPaper, thermalStyles as styles } from "../../generic-components/ThermalPaper";

/**
 * Compact sale receipt layout for 80mm thermal roll printers.
 * Rendered by SalePrintSummary when the operator chooses the Thermal layout.
 */
export function SaleThermalReceipt({ saleData, orgName, orgAddress, orgContact, hideOrgName, hideAmount, totals, netWeight, grossWeight, isWeightBasedItem, formatCurrency, formatDate }) {
    const items = saleData.itemsList || [];
    const inventoryItems = items.filter(i => i.itemType === 'INVENTORY');
    const materialNames = inventoryItems.map(i => i.inventoryItemName).filter(Boolean).join(', ');
    const singleItem = items.length === 1 ? items[0] : null;

    const parseNumber = (value) => {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? 0 : parsed;
    };

    const row = (label, value, big = false) => (
        <div style={styles.row}>
            <div style={styles.label}>{label}</div>
            <div style={{ ...styles.value, ...(big ? styles.valueBig : {}) }}>{value}</div>
        </div>
    );

    return (
        <ThermalPaper>
            {!hideOrgName && (
                <>
                    <div style={styles.orgName}>{orgName}</div>
                    {orgAddress && <div style={styles.orgDetail}>{orgAddress}</div>}
                    {orgContact && <div style={styles.orgDetail}>{orgContact}</div>}
                </>
            )}
            <div style={styles.title}>Sale Receipt</div>
            <div style={styles.divider}></div>

            {row('Date & Time', formatDate(saleData.salesSecondStepDate))}
            {row('Ticket Number', saleData.ticketSequenceNumber || '-')}
            {row('Vehicle', saleData.vehicleNumber || '-')}

            {items.length > 1 ? (
                <div style={styles.itemsBlock}>
                    {items.map((item, index) => (
                        <div key={index} style={styles.itemLine}>
                            {item.inventoryItemName || 'Item'} — {parseNumber(item.quantity)} {item.unitSymbol || ''}
                            {!hideAmount && <> @ {formatCurrency(parseNumber(item.price))}</>}
                        </div>
                    ))}
                </div>
            ) : (
                row('Material', materialNames || '-')
            )}

            {row('Customer', saleData.salesCustomer?.name || '-')}

            {isWeightBasedItem ? (
                <>
                    {row('Gross Weight', grossWeight > 0 ? `${grossWeight.toFixed(3)} Ton` : '-')}
                    {row('Tare Weight', saleData.emptyWeight ? `${saleData.emptyWeight} Ton` : '-')}
                    {row('Net Weight', netWeight > 0 ? `${netWeight.toFixed(3)} Ton` : '-', true)}
                </>
            ) : (
                row('Quantity', (() => {
                    const qty = parseNumber(inventoryItems[0]?.quantity);
                    const unitLabel = inventoryItems[0]?.unitSymbol || 'Units';
                    return qty > 0 ? `${qty} ${unitLabel}` : '-';
                })(), true)
            )}

            {!hideAmount && singleItem && row('Rate', formatCurrency(parseNumber(singleItem.price)))}
            {!hideAmount && row('Total Amount', formatCurrency(totals.grandTotal), true)}
            {row('Driver Name', saleData.driverName || '')}

            <div style={styles.divider}></div>
            <div style={styles.branding}>Powered by Revcon Technologies • revcontech.com</div>
        </ThermalPaper>
    );
}
